<template>
  <div>
    <top></top>
    <navMenu></navMenu>
    <div class="inner clearfix">
      <div class="indexworkleft fl">
        <taskleft></taskleft>
      </div>
      <div class="indexworkright fr">
        <el-row :gutter="20">
          <el-col :span="10"
            >作业名称：<strong>{{ this.assdata.title }}</strong></el-col
          >
          <el-col :span="6" class="worktypetitle"
            >任务类型：
            <el-button type="danger" v-show="this.assdata.storage == 2"
              >自定义作业</el-button
            >
            <el-button type="danger" v-show="this.assdata.storage == 1"
              >题库作业</el-button
            >
          </el-col>
          <el-col :span="8" class="worktypetitle">
            <el-button
              type="success"
              style="margin-left: 120px"
              v-show="this.assdata.storage == 1"
              @click="workreport"
              >作业报告</el-button
            >
          </el-col>
        </el-row>
        <div>
          题目: {{ this.worknum }}道 <span @click="lookwork">查看</span>
        </div>
        <div>作业描述：{{ this.assdata.notes }}</div>
        <div>
          发布班级： <span>{{ this.gradeid }}年级{{ this.classname }}</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="10"
            >发布时间：<span>{{ this.assdata.start_time }}</span></el-col
          >
          <el-col :span="10"
            >截止时间：<span>{{ this.assdata.end_time }}</span></el-col
          >
          <!-- <el-col :span="4">允许补交： <span>允许</span></el-col> -->
        </el-row>
        <div class="studentlistinfo clearfix">
          <el-row
            :gutter="5"
            v-for="item in this.studentlist"
            :key="item.user_id"
          >
            <el-col :span="4">
              <div>
                <img
                  v-show="
                    item.student_info.avatar != '' ||
                    item.student_info.avatar != ' '
                  "
                  :src="item.student_info.avatar"
                  alt=""
                  width="100%"
                />
                <img
                  v-show="
                    item.student_info.avatar == '' ||
                    item.student_info.avatar == ' '
                  "
                  :src="studetico"
                  alt=""
                  width="100%"
                />
              </div>
            </el-col>
            <el-col :span="6">{{ item.student_info.user_nicename }}</el-col>
            <el-col :span="10">{{ item.create_time }}</el-col>
            <el-col
              :span="4"
              @click.native="remarksbtn(item)"
              v-show="item.state != 1"
              ><i></i>
              <span v-show="item.state == 3">已批阅</span>
              <span v-show="item.state == 2">批阅</span>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <!-- 查看试题列表 -->
    <div class="checkquestionlistpopup" v-show="this.checkpopup == true">
      <div>
        <div class="questionstitle clearfix">
          <div @click="offpopup"><i class="el-icon-back"></i>返回</div>
          <div class="checkcontent">{{ this.assdata.title }}</div>
          <div class="checkright">
            <!-- <el-button type="primary" @click="postwork">保存</el-button> -->
          </div>
        </div>
        <div class="questionlist">
          <div
            class="questionlistdata clearfix"
            v-for="(item, index) in this.datatext"
            :key="index"
          >
            <div>
              <span>{{ index + 1 }}、</span>
              <!-- <div><span> </span><span>难度:  </span><span>添加时间:  </span></div> -->
              <div
                class="questionhtml"
                v-html="item.question_text"
                v-show="item.textype == 2"
              ></div>
              <div v-html="item.answer" v-show="item.textype == 2"></div>
              <div
                class="questionhtml"
                v-html="item.ques"
                v-show="item.textype == 1"
              ></div>
              <div v-html="item.ques" v-show="item.textype == 1"></div>
              <!-- <div class="questionhtml" v-show="item.texttype == 1" v-html="item.quetext"></div> -->
            </div>
          </div>
          <!-- //自定义作业 -->
          <div class="questionlistdata docimglist clearfix">
            <div
              class="workimglist"
              v-for="res in this.imgdata"
              :key="res"
              @click="previewimg(res)"
            >
              <div><img :src="res" alt="" /></div>
            </div>
            <div
              class="worklistdoc"
              v-for="(item, index) in this.docdata"
              :key="index"
              @click="worddown(item)"
            >
              <div :class="'work' + item.doctype"></div>
              <div>{{ item.docname }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="previewimg" v-show="this.previewimgtype == true">
      <span @click="offpreview">×</span>
      <img :src="this.urldata" alt="" />
    </div>
  </div>
</template>
<script>
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
import "../../assets/work.css";
import Taskleft from "../../components/work/taskleft.vue";
import URL from "../../api/index";
import eventBus from "@/api/eventBus";
import axios from "axios";
export default {
  data() {
    return {
      studetico: require("../../assets/liuyanban.png"),
      Token: "",
      assid: "",
      assinfo: "",
      textArr: [
        { value: "一" },
        { value: "二" },
        { value: "三" },
        { value: "四" },
        { value: "五" },
        { value: "六" },
        { value: "七" },
        { value: "八" },
        { value: "九" },
      ],
      assdata: "",
      gradeid: "",
      classname: "",
      studentlist: "",
      didnum: "",
      getwrlista: false,
      getwrlistb: false,
      liststa: 0,
      nocorrectnum: "",
      studentnum: "",
      nosubitnum: "",
      nosubitnums: "",
      subnum: "",
      notmitted: "",
      studentlist: [],
      checkpopup: false,
      docurl: [],
      docdata: [],
      imgdata: [],
      urldata: "",
      previewimgtype: false,
      idexamlist: [],
      datatext: [],
      worknum: "",
    };
  },
  components: {
    top,
    navMenu,
    Taskleft,
  },
  created() {},
  mounted() {
    this.Token = JSON.parse(localStorage.getItem("loginInfo")).token;
    this.assid = this.$route.query.assid;
    this.examid = this.$route.query.examid;
    this.getworkinfo();
    this.getPapersByAssign();
    this.getexam();
  },
  methods: {
    //文件下载
    worddown(val) {
      // console.log(val)
      var alink = document.createElement("a");
      alink.href = val.docurl;
      alink.download = val.docname; //图片名
      alink.click();
    },
    //作业报告
    workreport() {
      this.$router.push({
        name: "workreport",
        query: {
          assid: this.assid,
          examid: this.examid,
          greadid: this.gradeid,
          classname: this.classname,
        },
      });
    },
    //获取试题
    getexam() {
      var examdata = {
        token: this.Token,
        exam_id: this.examid,
      };
      this.$post(URL.GetByIdExam, examdata).then((getidexam) => {
        this.getcontentlist = getidexam.result;
        this.getlisttype = getidexam.result;
        // if( this.storage == '1' ){
        var i = 0;
        var getleng = this.getcontentlist.content.length;
        for (i; i < getleng; i++) {
          var cenlist = this.getcontentlist.content[i].scores.length;
          this.examleng += parseInt(cenlist);
          this.idexamlist = this.idexamlist.concat(
            this.getcontentlist.content[i].questions
          );
        }
        this.idexamlist.forEach((rs, index) => {
          // console.log(rs.question_text,"************")
          let rstype = rs.question_text.substring(0, 4);
          //题文解析 判断是否是链接
          if (rstype != "http") {
            this.idexamlist[index].textype = 2;
            this.datatext = this.idexamlist;
          } else {
            this.idexamlist[index].textype = 1;
            this.$get(rs.question_text).then((item) => {
              let urltext = rs.question_text.substring(0, 59); //地址获取
              let reg = new RegExp('src="', "g"); //获取src
              let answerquest = item.replace(reg, 'src="' + urltext); //src拼接
              rs.ques = answerquest;
              // this.datatext = this.idexamlist
            });
            this.$get(rs.answer).then((item) => {
              let urltext = rs.answer.substring(0, 59); //地址获取
              let reg = new RegExp('src="', "g"); //获取src
              let answerquest = item.replace(reg, 'src="' + urltext); //src拼接
              rs.answ = answerquest;
              setTimeout(() => {
                this.datatext = this.idexamlist;
              }, 100);

              // console.log(this.datatext)
            });
          }
        });
        // console.log(this.datatext)
        // }else{
        //     console.log("22")
        // }
      });
    },
    // 图片弹窗开关
    offpreview() {
      this.previewimgtype = false;
    },
    previewimg(val) {
      this.urldata = val;
      this.previewimgtype = true;
    },
    //返回
    offpopup() {
      this.checkpopup = false;
    },
    //作业数据详情
    getworkinfo() {
      var buiddata = {
        token: this.Token,
        assign_id: this.assid,
      };
      this.$post(URL.getAssignById, buiddata).then((res) => {
        this.assdata = res.result;
        // console.log(this.assdata)
        this.gradeid = this.textArr[res.result.class_info.grade_id - 1].value;
        this.classname = res.result.class_info.class_name;
        this.studentnum = " (" + this.assdata.student_num + ") ";
        this.nocorrectnum = "(" + this.assdata.nocorrect_num + ") ";
        this.nosubitnum = this.assdata.student_num - this.assdata.nocorrect_num;
        this.nosubitnums = " (" + this.nosubitnum + ") ";
        this.subnum = this.assdata.student_num;
        this.notmitted = this.assdata.student_num - this.assdata.nocorrect_num;
        this.didnum = this.assdata.did_num;
        this.worknum = JSON.parse(this.assdata.assign_extend).ques_num;
        // console.log(this.worknum);
        if (res.result.doc_url == null) {
          // worktype = 2
        } else {
          this.docurl = JSON.parse(res.result.doc_url); //课外文件列表
          // console.log(this.docurl)
          for (var i = 0; i < this.docurl.length; i++) {
            var index = this.docurl[i].name.lastIndexOf(".");
            var nameof = this.docurl[i].name.substring(
              index + 1,
              this.docurl[i].length
            );
            //针对文件后缀判断类型
            var filetype;
            if (nameof == "doc" || nameof == "docx") {
              this.docdata.push({
                docurl: this.docurl[i].url,
                doctype: "word",
                docname: this.docurl[i].name,
              });
            } else if (nameof == "xlsx" || nameof == "xls") {
              this.docdata.push({
                docurl: this.docurl[i].url,
                doctype: "excel",
                docname: this.docurl[i].name,
              });
            } else if (nameof == "txt") {
              this.docdata.push({
                docurl: this.docurl[i].url,
                doctype: "text",
                docname: this.docurl[i].name,
              });
            } else if (nameof == "pdf") {
              this.docdata.push({
                docurl: this.docurl[i].url,
                doctype: "pdf",
                docname: this.docurl[i].name,
              });
            } else if (
              nameof == "mp3" ||
              nameof == "wma" ||
              nameof == "wmv" ||
              nameof == "acc" ||
              nameof == "m4a"
            ) {
              this.docdata.push({
                docurl: this.docurl[i].url,
                doctype: "audio",
                docname: this.docurl[i].name,
              });
            } else if (nameof == "ppt" || nameof == "pptx") {
              this.docdata.push({
                docurl: this.docurl[i].url,
                doctype: "ppt",
                docname: this.docurl[i].name,
              });
            } else if (
              nameof == "png" ||
              nameof == "jpg" ||
              nameof == "jpeg" ||
              nameof == "webp" ||
              nameof == "gif" ||
              nameof == "PNG " ||
              nameof == "JPG" ||
              nameof == "JPEG" ||
              nameof == "webp" ||
              nameof == "GIF"
            ) {
              this.imgdata.push(this.docurl[i].url);
            } else if (
              nameof == "mp4" ||
              nameof == "avi" ||
              nameof == "mov" ||
              nameof == "ram"
            ) {
              this.docdata.push({
                docurl: this.docurl[i].url,
                doctype: "video",
                docname: this.docurl[i].name,
              });
            } else {
              this.docdata.push({
                docurl: this.docurl[i].url,
                doctype: "other",
                docname: this.docurl[i].name,
              });
            }
          }
        }
        // 数据上报
        this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")));
      });
    },
    //学生列表
    getPapersByAssign() {
      var gerassign = {
        assign_id: this.assid,
        state: 0,
        token: this.Token,
      };
      this.$post(URL.getPapersByAssign, gerassign).then((res) => {
        this.studentlist = res.result;
      });
    },
    remarksbtn(val) {
      if (val.state == 3) {
        //已批阅
      } else if (val.state == 2) {
        this.$router.push({
          name: "remarks",
          query: {
            paperid: val.paper_id,
          },
        });
      }
    },
    lookwork() {
      this.checkpopup = true;
      // this.$router.push({
      //     name: 'workreport'
      // })
    },
    // 数据上报
    getRecordRjw(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "teahomework_look",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了作业的查看功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("work_traceid")),
            job_name: this.assdata.title,
            job_describe: this.assdata.notes,
            grade_id:
              this.assdata.class_info && this.assdata.class_info.grade_id,
            grade_name: this.gradeid + "年级",
            class_id: "",
            class_name: this.classname,
            issue_time: this.assdata.start_time,
            deadline: this.assdata.end_time,
            task_type: this.assdata.storage == 1 ? "题库作业" : "自定义作业",
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
  },
};
</script>
<style scoped>
.indexworkleft {
  background: none;
  padding: 0 10px 0 0;
}
.inner {
  margin-top: 15px;
}
body,
html,
div,
blockquote,
img,
label,
p,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
ul,
ol,
li,
dl,
dt,
dd,
form,
a,
fieldset,
input,
th,
td,
i,
em {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}
</style>